/**
 * @param {string} country
 * @param {*} value
 * @param {boolean} validationValue
 * @returns {boolean}
 */
function ssn ({ country, value, validationValue }) {
  return require('./locales')?.[country]?.ssn({ value, validationValue }) || false
}

module.exports = { ssn }
